import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// sessionStorage is tab-scoped: switching organisation in one tab must not silently
// retarget authenticated requests made by another tab/session.
api.interceptors.request.use((config) => {
  const organisationId = sessionStorage.getItem("active_organisation_id");
  if (organisationId) config.headers["X-Organisation-ID"] = organisationId;
  return config;
});

export function setActiveOrganisationId(organisationId) {
  if (organisationId) sessionStorage.setItem("active_organisation_id", organisationId);
  else sessionStorage.removeItem("active_organisation_id");
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") {
    if (/^(request failed with status code|network error|internal server error)/i.test(detail))
      return "Something went wrong. Please try again.";
    return detail;
  }
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
